<script lang="ts">
  import { trips } from '../lib/state';
  import { tripBlendedScore, tripTimeClass, scoreClass } from '../lib/scoring';
  import type { Candidate, TripLegData } from '../lib/types';

  export let candidate: Candidate;

  $: score = tripBlendedScore(candidate, $trips);
  $: hasData = candidate.trips && Object.keys(candidate.trips).length > 0;

  function scoreColors(s: number | null) {
    const cls = s != null ? scoreClass(s) : null;
    const bg = cls === 'good' ? '#d4edda' : cls === 'mid' ? '#fff3cd' : '#f8d7da';
    const fg = cls === 'good' ? 'var(--good)' : cls === 'mid' ? 'var(--mid)' : 'var(--warn)';
    return { bg, fg };
  }

  type Leg = { kind: 'drive' | 'transit'; name: string; data: { minutes: number | null } | undefined };
  $: legs = ($trips.flatMap((t) => {
    const d: TripLegData = candidate.trips[t.id] || {};
    return [
      { kind: 'drive', name: t.name, data: d.driving },
      { kind: 'transit', name: t.name, data: d.transit },
    ];
  }) as Leg[]);
</script>

{#if $trips.length}
  <div class="section-title" style="margin-top: 20px;">
    Places
    {#if score != null}
      {@const col = scoreColors(score)}
      <span class="key-status" style={`background:${col.bg}; color:${col.fg};`}>{score} / 100</span>
    {/if}
  </div>
  {#if !hasData}
    <div class="loading">Computing drive times...</div>
  {:else}
    <div class="amenities-grid">
      {#each legs as leg}
        <div class="amenity-row">
          <div class="amenity-label">{leg.name} · {leg.kind}</div>
          {#if !leg.data || leg.data.minutes == null}
            <div class="amenity-place"><span class="muted">No route</span></div>
            <div class="amenity-time bad">—</div>
          {:else}
            <div class="amenity-place"></div>
            <div class="amenity-time {tripTimeClass(leg.data.minutes)}">{leg.data.minutes}m</div>
          {/if}
        </div>
      {/each}
    </div>
    <p class="help-text" style="margin-top: 6px;">Drive time with traffic; transit is computed for next Friday at 6pm. The score uses whichever is faster.</p>
  {/if}
{/if}
